module.exports = __webpack_public_path__ + "static/media/instagram.878e4fe2.svg";